module.exports = __webpack_public_path__ + "img/back02_sp.42ac9d0a.jpg";